import Layout from "../layout";
import Card from "../../components/Card";
import Form from "./Form";

export default function Home() {
  return (
    <Layout>
      <Card>
        <Form />
      </Card>
    </Layout>
  );
}
